import { Box, Grid } from '@mui/material'
import { isArray } from 'lodash';
import React, { useEffect } from 'react'
import { FieldValues, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import AppSelectList, {
} from '../../../../Component/Common/Components/FormValidationInputs/AppSelectList';
import { MDTypography } from '../../../../Component/Common/Components/MDTypography'
import { VerificationCompanyAtom } from '../../../../State/VerificationCompany.Atom';
import {
    VerificationAgencyClientApplication
} from "../../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClientApplication";
import {
    VerificationAgencyClientApplicationService
} from "../../../../Component/Api/VerificationAgency/VerificationAgencyClientApplication/VerificationAgencyClientApplicationService";
import { LoadingButton } from "@mui/lab";
import AppTextInput from "../../../../Component/Common/Components/FormValidationInputs/AppTextInput";
import AppCurrencyInput from "../../../../Component/Common/Components/FormValidationInputs/AppCurrencyInput";
import { AppDatepicker } from "../../../../Component/Common/Components/FormValidationInputs/AppDatepicker";
import { accountTypeList } from "../../../../Component/Common/Constants/Lists/DropdownListOptions";
import { offsetTimezone } from "../../../../Component/Model/helpers";
import { yupResolver } from "@hookform/resolvers/yup";
import { FinancialInformationValidationSchema } from "./FinancialInformationValidationSchema";
import { MDButton } from '../../../../Component/Common/Components/MDButton';

interface IFinancialServicesExternalPage {
    token: string;
    setHandleNextCount: (i: number) => void;
    handleNextCount: number;
}
export const FinancialInformationDetailsExternalPage = (props: IFinancialServicesExternalPage) => {

    const verificationCompany = useRecoilValue(VerificationCompanyAtom);
    const [loading, setLoading] = React.useState(false);
    const [financialDetails, setFinancialDetails] = React.useState(-1);
    const { control, handleSubmit, formState: { isSubmitting }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(FinancialInformationValidationSchema),
    });

    const handleDataSubmit = async (data: FieldValues) => {
        try {
            const requestData = {
                vaClientApplicationId: verificationCompany.applicationId,
                turnover: data.turnover,
                netProfitAfterTax: data.netProfitAfterTax,
                numberOfEmployees: data.numberOfEmployees,
                financialYearEnd: offsetTimezone(new Date(data.financialYearEnd)),
                accountType: data.accountType.toString(),
                token: props.token
            } as VerificationAgencyClientApplication.VerificationAgencyFinancialInformationTempAccessDto;

            if (financialDetails < 0) {
                await VerificationAgencyClientApplicationService.CreateFinancialInformationExternalPage(requestData);
            }
            else {
                await VerificationAgencyClientApplicationService.UpdateFinancialInformationExternalPage(requestData);
            }
            props.setHandleNextCount(props.handleNextCount + 1);
            toast.success("Financial Information Details Saved")
        } catch (error: any) {
            console.log(error);
            if (isArray(error)) {
                let Errors: string[] = error;
                Errors.forEach((error: string) => {
                    toast.error(error);
                });
            }
        }
    }

    const getFinancialDetails = async () => {
        const id = verificationCompany.applicationId;

        if (id !== -1) {
            try {
                const response = await VerificationAgencyClientApplicationService.GetFinancialInformationExternalPage(props.token);
                setFinancialDetails(response.data.financialInformationId || -1);

                reset(response.data);
            } catch (error) {
                console.log(error);
            }
        }
    }

    useEffect(() => {
        setLoading(true);
        getFinancialDetails();
        setLoading(false);
    }, [])

    return (
        <Box>
            <MDTypography color='#000000' variant='h5' fontWeight='bold' >
                Financial Information
            </MDTypography>
            <MDTypography sx={{ fontSize: "15px", paddingBottom: "20px", paddingTop: "8px", color: "#727272" }}>
                Provide key financial details like net profit after tax. This information is critical for evaluating the economic impact of BEE initiatives and to ensure that you are verified and/or providing with information relating to the correct scorecard type.
            </MDTypography>
            <form id='FinancialDetailsForm' onSubmit={handleSubmit(handleDataSubmit)}>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <Box>
                            <AppCurrencyInput control={control} name="turnover" label="Turnover" />
                        </Box>
                        <Box mt={2}>
                            <AppTextInput control={control} name="numberOfEmployees" label="Number Of Employees" />
                        </Box>
                        <Grid mt={2}>
                            <AppSelectList control={control} name="accountType" label="Audited AFS or Management Accounts" items={accountTypeList} />
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Box>
                            <AppCurrencyInput control={control} name="netProfitAfterTax" label="Net Profit After Tax" />
                        </Box>
                        <Box mt={2}>
                            <AppDatepicker control={control} name="financialYearEnd" label="Financial Year End" inputFormat='yyyy/MM/dd' />
                        </Box>
                    </Grid>
                </Grid>
                <Box mt={3} width='100%' display='flex' justifyContent='space-between'>
                    <Box>
                        <MDButton variant='outlined' color='secondary' onClick={() => { props.setHandleNextCount(props.handleNextCount - 1); }}>
                            Previous
                        </MDButton>
                    </Box>
                    <LoadingButton loading={isSubmitting} variant='contained' form='FinancialDetailsForm' type="submit" color='primary'>
                        Next
                    </LoadingButton>
                </Box>
            </form>
        </Box>
    )
}
